<template>
  <div>
    <ModalNewsletterConfirm
      v-if="isEmailVerified && !isNewsletterAbo && !hadNewsletterOnce"
      @hidden="completeStep"
    />
  </div>
</template>

<script>
import ModalNewsletterConfirm from "@/components/notification/modal-newsletter-confirm.vue";

export default {
  name: "PipeNewsletterConfirm",
  components: {
    ModalNewsletterConfirm,
  },
  data() {
    return {
      completed: false,
    };
  },

  computed: {
    isEmailVerified: function () {
      return this.$store.getters["user/currentUser"].email_verified_at;
    },
    hadNewsletterOnce: function () {
      return this.$store.getters["user/currentUser"].newsletter_at;
    },
    isNewsletterAbo: function () {
      return this.$store.getters["user/currentUser"].newsletter;
    },
  },
  mounted() {
    console.log("--------- Pipeline Step NewsletterConfirm ----------");
    this.$store.dispatch("user/increaseNewsletterReminderCounter");

    if (
      !this.isEmailVerified ||
      this.isNewsletterAbo ||
      this.hadNewsletterOnce ||
      !this.$store.getters["user/showNewsletterReminderModal"]
    ) {
      this.completeStep();
      return;
    }

    this.$bvModal.show("modal-newsletter-confirm");
  },
  methods: {
    completeStep() {
      if (this.completed) {
        return;
      }

      this.completed = true;
      this.$store.commit("popups/setNextPipelineQueueStep");
    },
  },
};
</script>

<style scoped lang="scss"></style>
